import { configureStore } from "@reduxjs/toolkit";
import usersReducer from "./usersSlice";

export const store = configureStore({
  reducer: {
    users: usersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore non-serializable Firebase User objects in setUser payload
        ignoredActions: ['users/setUser', 'users/setSelectedAffiliation'],
        ignoredPaths: ['users.currentUser.id', 'users.currentUser.email'],
      },
    }),
  devTools: true, // Enable Redux DevTools for debugging
});

// Infer types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;